import { render, staticRenderFns } from "./OpeningMessagesEditor.vue?vue&type=template&id=0036d752&scoped=true&"
import script from "./OpeningMessagesEditor.vue?vue&type=script&lang=js&"
export * from "./OpeningMessagesEditor.vue?vue&type=script&lang=js&"
import style0 from "./OpeningMessagesEditor.vue?vue&type=style&index=0&id=0036d752&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0036d752",
  null
  
)

export default component.exports